import objectFitImages from "object-fit-images";
import innerHeight from "ios-inner-height";
import lottie from "lottie-web";
import Odometer from "odometer";
export default {
  init() {
    // Cover
    objectFitImages();

    // ODOMETER
    //if div.odometer-container is in windows view
    function isScrolledIntoView(elem) {
      var docViewTop = $(window).scrollTop();
      var docViewBottom = docViewTop + $(window).height();

      var elemTop = $(elem).offset();
      if (elemTop == undefined) return false;
      elemTop = elemTop.top;
      var elemBottom = elemTop + $(elem).height();

      return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }

    // on page loaded
    // window.addEventListener("load", function () {
    $(".flip-width").each(function () {
      //save width of child with class invisible
      var width = $(this).find(".invisible").width();
      var offsetjustincase = 15;
      width = width + offsetjustincase;
      $(this).find(".invisible").hide();

      //apply width to child .flip
      $(this).find(".flip").css("width", width);
    });
    // });

    $(window).on("scroll load", function () {
      if (isScrolledIntoView(".odometer-container")) {
        $(".flip").each(function () {
          let el = this;

          const odFromZero = new Odometer({
            el: el,
            value: 0,
            format: "",
            theme: "minimal",
          });
          //get this .flip html data
          let odValue = $(this).data("value");

          odFromZero.update(odValue);
        });
      }
    });

    // Link target blank
    $("a").each(function () {
      var a = new RegExp("/" + window.location.host + "/");
      if (!a.test(this.href)) {
        $(this).attr("target", "_blank");
      }
    });

    // Toggle main navigation
    document
      .querySelector(".toggle-burguer")
      .addEventListener("click", function (e) {
        document.body.classList.toggle("show-nav");
      });

    document.querySelectorAll(".toggle-search").forEach(function (e) {
      e.addEventListener("click", function (element) {
        document.body.classList.toggle("show-search");
      });
    });

    // Front animation
    var animData = {
      container: document.getElementById("animation"),
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: $("#animation").attr("data-url"),
    };

    var anim = lottie.loadAnimation(animData);

    // Days filter
    $(".days-filter button").on("click", function () {
      var element = $(this);
      var day = element.attr("data-filter");

      $(".days-filter button").removeClass("active");
      element.addClass("active");

      $(".event-item").addClass("hidden");
      $(".event-item." + day).removeClass("hidden");
    });

    $(document).keyup(function (e) {
      if (e.key === "Escape") {
        document.body.classList.remove("show-search");
      }
    });
  },
  finalize() {
    // Heights
    $(".h-screen").css("height", innerHeight() + "px");
    $(".min-h-screen").css("min-height", innerHeight() + "px");

    $(window).resize(function () {
      $(".h-screen").css("height", innerHeight() + "px");
      $(".min-h-screen").css("min-height", innerHeight() + "px");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js